import { useEffect, useState } from 'react'
import { getUser, isSignedIn, onUserChange, getUsername } from '../lib/user'
import { dailyStreak } from '../lib/storage'
import { isPlus } from '../lib/user'

export function openAuth() { dispatchEvent(new CustomEvent('wayoff:auth')) }
export function openHowTo() { dispatchEvent(new CustomEvent('wayoff:howto')) }

/** One top bar everywhere: brand, nav, and EITHER the profile chip OR the sign-in button — never both. */
export function TopBar({ nav = true }: { nav?: boolean }) {
  const [, force] = useState(0)
  const [name, setName] = useState('')
  useEffect(() => onUserChange(() => force((x) => x + 1)), [])
  const signed = isSignedIn()
  useEffect(() => {
    let alive = true
    const fetchName = () => { if (isSignedIn()) getUsername().then((n) => { if (alive && n) setName(n) }).catch(() => {}) }
    fetchName()
    const t = setTimeout(fetchName, 1500) // first load can race the auth/profile sync
    const un = onUserChange(fetchName)
    return () => { alive = false; clearTimeout(t); un() }
  }, [signed])
  const streak = dailyStreak(undefined, isPlus())
  return (
    <div className="topbar">
      <a className="brand" href="#/">Way <b>Off</b></a>
      <nav>
        {nav && (
          <span className="navlinks">
            <a href="#/bonus">⚡ Bonus</a>
            <a href="#/stats">Stats</a>
            <a href="#/archive">History</a>
            {isPlus()
              ? <a href="#/practice" className="plus-nav">✦ Practice</a>
              : <a href="#/plus" className="plus-nav">✦ Plus</a>}
          </span>
        )}
        <button className="linkish" onClick={openHowTo} aria-label="how to play">?</button>
        {signed ? (
          <a className="profile-chip" href="#/account" aria-label="your profile">
            <span className="avatar">{(name || getUser()?.displayName || '☺').slice(0, 1).toUpperCase()}</span>
            <span className="pname">{name || getUser()?.displayName || 'profile'}</span>
            {streak > 0 && <span className="pstreak">🔥{streak}</span>}
          </a>
        ) : (
          <button className="login-btn" onClick={openAuth}>Sign up / Login</button>
        )}
      </nav>
    </div>
  )
}
